import React from 'react'
import { SlIcon} from '@shoelace-style/shoelace/dist/react';

function NoDataFound({ colspan }) {
  return (
    <>
      <tbody><tr><td colSpan={parseInt(colspan)} className="py-10" style={{ textAlign: "center"}}>
        <div className='no-data'>
      <svg data-v-5eed88b5="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="bird-icon flip" strokeWidth="1"><path d="M16 7h.01"></path><path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"></path><path d="m20 7 2 .5-2 .5"></path><path d="M10 18v3"></path><path d="M14 17.75V21"></path><path d="M7 18a6 6 0 0 0 3.84-10.61"></path></svg>
        <h2>No Data Found</h2>
      </div>
         </td></tr></tbody>
    </>

  )
}

export default NoDataFound